import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
        <div className="prose max-w-none bg-white p-8 rounded-lg shadow-sm">
          <p className="text-sm text-gray-600 mb-6">Last Updated: January 2025</p>
          
          <h2>1. Information We Collect</h2>
          <p>We collect information you provide when creating an account, requesting quotes, or using our services. This includes name, email, and project details.</p>
          
          <h2>2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Connect you with service professionals</li>
            <li>Process payments and subscriptions</li>
            <li>Improve our platform</li>
            <li>Send service updates and notifications</li>
            <li>Comply with legal obligations</li>
          </ul>
          
          <h2>3. Information Sharing</h2>
          <p>We share your contact information with professionals when you request quotes. We do not sell your personal information to third parties.</p>
          
          <h2>4. Data Security</h2>
          <p>We implement industry-standard security measures to protect your data. All payment information is processed through Stripe's secure platform.</p>
          
          <h2>5. Cookies</h2>
          <p>We use cookies to enhance your experience, analyze usage, and provide personalized content. You can control cookie settings in your browser.</p>
          
          <h2>6. Your Rights</h2>
          <p>You have the right to access, update, or delete your personal information. Contact us at privacy@profind.ca to exercise these rights.</p>
          
          <h2>7. Children's Privacy</h2>
          <p>Our service is not intended for users under 18 years of age. We do not knowingly collect information from children.</p>
          
          <h2>8. Changes to Policy</h2>
          <p>We may update this policy periodically. We will notify users of significant changes via email or platform notification.</p>
          
          <h2>9. Contact Us</h2>
          <p>For privacy-related questions, email us at privacy@profind.ca</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPage;